import React from 'react'
import Container from 'react-bootstrap/Container';
import Table from 'react-bootstrap/Table';
import { Button } from 'react-bootstrap';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import { Link } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import * as AiIcons from "react-icons/ai";
import UpdateAreaN2 from './UpdateAreaN2';
import { FaEdit } from "react-icons/fa";
import { MdAccountTree } from "react-icons/md";
import { BsPersonLinesFill } from "react-icons/bs";
import UpdatePosicion from './UpdatePosicion';
import { dtFormatter } from './AuxiliaryFunctions';
import UpdateOrganigrama from './UpdateOrganigrama';
import { FaGear } from "react-icons/fa6";

const TableHeader = (props) => {
  return (

    <thead>
      <tr>
        <th style={{width:'8%'}}>ID Organigramas</th>
        <th style={{width:'15%'}}>Nombre Organigrama</th>
        <th style={{width:'35%'}}>Descripción Organigrama</th>
        <th style={{width:'5%'}}>{props.mode==0?'Editar ':''}</th>
        <th style={{width:'5%'}}>Config</th>
      </tr>
    </thead>
  )
}

const TableBody = (props) => {  
  
  if (props.listOfOrganigramas) {
    
    const rows = props.listOfOrganigramas.map((row, index) => { 
      return (      
        <tr key={index}>        
          <td>
            {"ORG-" + row.id}
          </td>
          <td>  
            {row.nombreorganigrama}
          </td>
          <td>  
            {row.descripcionorganigrama}
          </td>          
          <td align='center'>  
            {(props.mode==0) && // editar
              <OverlayTrigger
                placement="right"
                delay={{ show: 250, hide: 400 }}
                overlay={renderEditTooltip}>        
                <UpdateOrganigrama 
                  editrow = {row}
                  id = {row.id}
                  nombreorganigrama = {row.nombreorganigrama}
                  descripcionorganigrama = {row.descripcionorganigrama}
                  mode={0}/>    
              </OverlayTrigger>              
            }
            {(props.mode==1) && // seleccionar
              <Button onClick={() => {
                //console.log(row);
                props.onSelected(row.id,row.nombreorganigrama,row.descripcionorganigrama);
                props.handleClose();
              }} variant='link' value={row.id}>Seleccionar</Button>
            } 
          </td>   
          <td>
            <Button variant="secondary">
              <Link to = {`/editorganigramaareas/${row.id}`}><FaGear size={15} color='white'/></Link>      
            </Button>          
          </td>

        </tr>
      )
    })
    return (
      <tbody>
        {rows}
      </tbody>
    )  
  }
  else {
    return null;
  }
}

const renderEditTooltip = (props) => (
  <Tooltip id="button-tooltip" {...props}>
    Click to edit the user.
  </Tooltip>
);

const OrganigramasList = (props) => {        
  //console.log(props);
  return (
      <>
      <Container>
        <Row>
          <Table style={{verticalAlign:"baseline"}} striped bordered hover size="sm">
            <TableHeader mode={props.mode}/>
            <TableBody row={props.row} mode={props.mode} handleClose={props.handleClose} onSelected={props.onSelected} arean2id={props.arean2id} listOfOrganigramas={props.listOfOrganigramas} />
          </Table>
        </Row>
        <hr/>
      </Container>
      </>
    );
}

export default OrganigramasList;